import React from "react";
import CommonButtons from "../../../../../shared/components/CommonButtons";
import { ModalWrapper } from "../../../../../shared/components/ModalWrapper";
import CommonTextField from "../../../../../shared/components/CommonTextField";

interface CustomerDialogProps {
  customerAdd: boolean;
  handleCloseCustomer: () => void;
  customerName: string;
  setCustomerName: (value: string) => void;
  phoneNumber: string;
  setPhoneNumber: (value: string) => void;
  // tableNumber: string;
  // setTableNumber: (value: string) => void;
  handleSubmit: (customerId?: string) => void;
  searchTerm: string;
  setSearchTerm: (value: string) => void;
}

const CustomerDialog: React.FC<CustomerDialogProps> = ({ customerAdd, handleCloseCustomer, customerName, setCustomerName, phoneNumber, setPhoneNumber, handleSubmit, searchTerm, setSearchTerm }) => {
  if (!customerAdd) return null;

  const fields = [
    { label: "Customer Full Name", value: customerName, setter: setCustomerName, name: "customerName", placeholder: "Enter full name" },
    { label: "Mobile Number", value: phoneNumber, setter: (value: string) => {
      // Allow only digits, limit to 8
      const numericValue = value.replace(/\D/g, "").slice(0, 8);
      setPhoneNumber(numericValue);
    }, name: "phoneNumber", placeholder: "Enter mobile number" },
    // { label: "Table Number", value: tableNumber, setter: setTableNumber, name: "tableNumber", placeholder: "Enter table number" },
  ];

  const isFormValid =
  customerName.trim().length > 0 &&
  phoneNumber.trim().length === 8;

  return (
    <ModalWrapper title="Enter Customer Details" onClose={handleCloseCustomer} showCloseButton width="max-w-lg">
      <div className="space-y-4">
        {fields.map((field) => (
          <CommonTextField key={field.name} label={field.label}  name={field.name} value={field.value} onChange={(e) => field.setter(e.target.value)} required={true} placeholder={field.placeholder} />
        ))}
      </div>

      <div className="flex justify-end items-center pt-6 gap-6">
        <CommonButtons label="Cancel" className="w-32" variant="outlineDanger" onClick={handleCloseCustomer} />
        <CommonButtons label="Save Customer" className="w-40" onClick={() => handleSubmit()} disabled={!isFormValid} />
      </div>
    </ModalWrapper>
  );
};

export default CustomerDialog;
